import { ViewportScroller } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DoctorServiceService } from '../api-services/doctor-service.service';
import { EmrService } from '../api-services/emr/emr.service';

@Component({
  selector: 'app-emr-registration',
  templateUrl: './emr-registration.component.html',
  styleUrls: ['./emr-registration.component.css']
})
export class EmrRegistrationComponent implements OnInit {
  @ViewChild('msg') modalRef;
  emrForm = new FormGroup({
    emrId: new FormControl(""),
    fullName: new FormControl("", [Validators.required, Validators.minLength(3), Validators.maxLength(35), Validators.pattern('^[a-zA-Z \-\']+')]),
    email: new FormControl('', [Validators.required, Validators.email]),
    mobile: new FormControl('', [Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern(/^-?(0|[1-9]\d*)?$/)]),
    practiceCityName: new FormControl(''),
    panchKarmaFacility: new FormControl('', Validators.required),
    ayurvedaEMR: new FormControl(""),
    country: new FormControl(""),
    state: new FormControl(""),
    city: new FormControl("")
  })
  check: boolean;
  formErrors: any = {
    data: '',
    bool: false
  };
  states: any;
  cities: any;
  countries: any;
  countryOthers;
  stateOthers;
  cityOthers;
  constructor(private emrService: EmrService, private modalService: BsModalService, private scroller: ViewportScroller, private router: Router,
    private doctor_service: DoctorServiceService) { }

  ngOnInit(): void {
    this.getCountry();
  }
  modalClose() {
    this.modalService.config.initialState = "";
    this.modalService.hide();
    if (this.check) {

      this.router.navigate(['/products'])
    }
  };

  resetForm() {
    this.emrForm.reset();
    this.scroller.scrollToAnchor('scrollForError');
  }


  submitEmr() {
    if (!this.emrForm.valid) {
      this.emrForm.markAllAsTouched();
      this.scroller.scrollToAnchor('scrollForError');
    } else {
      this.other()
    
     
    }
  };
  
   emrReg(){
    this.emrService.emrRegistration(this.emrForm.value).subscribe((res: any) => {
      if (res.status) {
        this.check = true
        this.modalService.show(this.modalRef, {
          class: 'modal-sm',
          backdrop: 'static',
          keyboard: false,
          initialState: {
            message: 'Registration has been successfully submited'
          }
        });

      } else {
        this.modalService.show(this.modalRef, {
          class: 'modal-sm',
          backdrop: 'static',
          keyboard: false,
          initialState: {
            message: res.message
          }
        });
      }
    }, (err: any) => {
      if (err.status === 400) {
        this.scroller.scrollToAnchor('forExitEmail')
        this.formErrors['data'] = err.error.data;
        this.formErrors['bool'] = err.error.error;
      }
    })
   }

  getCountry() {
    this.doctor_service.getCountry().subscribe((data: any) => {
      let obj = { countryId: -1, countryName: 'Other' }
      data.push(obj)
      this.countries = data
    });

  }

  getState(CountryId: any) {


    if (this.emrForm.get('country').value.countryId != -1) {

      this.emrForm.get('state').patchValue('');
      this.emrForm.get('city').patchValue('');
      this.doctor_service.getState(CountryId.countryId).subscribe((data: any) => {
        let obj = { stateId: -1, stateName: 'Other' }
        data.push(obj)
        this.states = data

      });
    } else {
      this.states =[];
      this.cities =[]
      this.emrForm.get('state').patchValue({ stateId: -1, stateName: 'Other' });
      this.emrForm.get('city').patchValue({ cityId: -1, cityName: 'Other' });
    }
  };
  getCity(StateId: any) {
    if (this.emrForm.get('state').value.stateId != -1) {
      this.emrForm.get('city').patchValue('');
      this.doctor_service.getCity(StateId.stateId).subscribe((data: any) => {
        let obj = { cityId: -1, cityName: 'Other' }
        data.push(obj)
        this.cities = data
      });
    } else {
      this.cities =[]
      this.emrForm.get('city').patchValue({ cityId: -1, cityName: 'Other' });
    }
  };

  other() {
    if (this.emrForm.get('country').value.countryId == -1) {
      this.emrForm.get('country').patchValue(this.countryOthers);
    }else{
      this.emrForm.get('country').patchValue(this.emrForm.get('country').value.countryName);
    };
    if (this.emrForm.get('state').value.stateId == -1) {
      this.emrForm.get('state').patchValue(this.stateOthers);
    }
    else{
      this.emrForm.get('state').patchValue(this.emrForm.get('state').value.stateName);
    }
    if (this.emrForm.get('city').value.cityId == -1) {  
      this.emrForm.get('city').patchValue(this.cityOthers);
    }else{
      this.emrForm.get('city').patchValue(this.emrForm.get('city').value.cityName);
    }
    this.emrReg();
  }

}
